var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroupSymbol(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 50.8226,
    height: 87.3482,
    viewBox: "0 0 50.8226 87.3482",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20.7564 67.2386V87.3482L0 75.2879V27.0469L15.0262 22.9131V63.9098L20.7564 67.2386Z",
    fill: "#6B97CF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M35.7826 57.2862V75.97L20.7564 67.2386V21.3305L15.0262 22.9131V15.6688L30.0525 11.535V53.9574L35.7826 57.2862Z",
    fill: "#4E7ABC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M50.8226 0V66.0176L35.7826 57.2862V9.95244L30.0525 11.535V5.71634L50.8226 0Z",
    fill: "#305CA7"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupSymbol);
export default __webpack_public_path__ + "static/media/group-symbol.96c748a46257fb4580f5e389873e153f.svg";
export { ForwardRef as ReactComponent };